import { connect } from 'react-redux';
import { fetchNotifications } from 'notifications/store/NotificationSlice';
import { fetchEditPtoDetails, resetEditPto, updateEditPtoField } from '../store/editOrderDetails';
import { fetchProductBalance } from '../store/productBalance';
import { resetCreatePto } from '../store/createOrder';
import {
  fetchOriginatorLocationProductReidVaporPressures,
  getOriginatorLocationRvpOptions,
} from '../store/originatorLocationProductReidVaporPressures';
import {
  fetchReidVaporPressures,
  reidVaporPressureOptionsSelector,
} from '../store/reidVaporPressures';
import {
  fetchOriginatorLocationProducts,
  originatorLocationProductOptionsSelector,
} from '../store/originatorLocationProducts';
import { affiliateOptionsSelector, fetchAffiliates } from '../store/affiliates';
import { fetchPtoDetails } from '../store/orderDetails';
import { setCurrentPtoDialogueOpen } from '../store/orderDrawer';
// eslint-disable-next-line import/no-cycle
import EditPtoPanel from './EditPanel';

const mapState = state => ({
  affiliatesError: state.pto.affiliates.error,
  editPtoDetails: state.pto.editPtoDetails,
  originatorLocationProductsError: state.pto.originatorLocationProducts.error,
  productBalance: state.pto.productBalance.productBalance,
  productOptions: originatorLocationProductOptionsSelector(state),
  recipientOptions: affiliateOptionsSelector(state),
  reidVaporPressuresError: state.pto.reidVaporPressures.error,
  rvpOptions: reidVaporPressureOptionsSelector(state),
  uniqueLocationProductRVPs: getOriginatorLocationRvpOptions(state),
});

const mapDispatch = {
  fetchAffiliates,
  fetchEditPtoDetails,
  fetchNotifications,
  fetchOriginatorLocationProductReidVaporPressures,
  fetchOriginatorLocationProducts,
  fetchProductBalance,
  fetchPtoDetails,
  fetchReidVaporPressures,
  resetCreatePto,
  resetEditPto,
  setCurrentPtoDialogueOpen,
  updateEditPtoField,
};

export default connect(mapState, mapDispatch)(EditPtoPanel);
